import { createFileRoute } from '@tanstack/react-router'
import type { UserProfileUpdate } from '@workspace/seedforge-ui/user-profile'
import { UserProfileView } from '@workspace/seedforge-ui/user-profile'
import { FounderLayout } from '../../../../components/founder-layout'
import { useStartupContext } from '../../../../contexts/startup-guard'
import { useUpdateUserMutation } from '../../../../hooks/api'

export const Route = createFileRoute('/app/startup/$id/me')({
  component: StartupProfilePage,
})

function StartupProfilePage() {
  const { user } = useStartupContext()
  const updateUser = useUpdateUserMutation()

  const handleSave = (update: UserProfileUpdate) => {
    updateUser.mutate({ body: update })
  }

  return (
    <FounderLayout activeNav="">
      <UserProfileView
        profile={{
          name: user.name,
          email: user.email,
          image: user.image,
          bio: user.bio,
          location: user.location,
          websiteUrl: user.websiteUrl,
          linkedinUrl: user.linkedinUrl,
          twitterUrl: user.twitterUrl,
          githubUrl: user.githubUrl,
        }}
        onSave={handleSave}
        isSaving={updateUser.isPending}
      />
    </FounderLayout>
  )
}
